import './scss/app.scss';
import './scss/main.scss';
import './scss/main-responsive.scss';

import {TweenMax, TimelineMax, Power4, CSSPlugin, gsap} from 'gsap';

gsap.registerPlugin(CSSPlugin);

// Browser detection message
$(function() {
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');

    if (msie > 0) {

        var message = document.createElement('div');
        message.classList.add('ie-message');
        message.innerHTML = `<div>Sorry, it looks like you're using a browser that isn't currently supported by <img alt="SurePeople" src="img/logo.svg" />.<br/><br/> Please download one of these browsers and you will be on your way:</div>`;

        document.body.append(message);

        document.documentElement.classList.add('isIE');

    }
});

// Collapsible
$(function () {
    var element = document.querySelectorAll('[data-collapsible="true"]');

    for (var i = 0; i < element.length; i++) {
        element[i].onclick = function (e) {
            e.preventDefault();

            var that = this,
                thatParent = that.parentNode;

            $(element).parent().siblings().find($(element).not(that)).removeClass('is-active');
            $(element).parent().siblings().find('.collapsible-content').css({
                maxHeight: '',
            });

            if (!that.classList.contains('is-active')) {
                that.classList.add('is-active');
                thatParent.querySelector('.collapsible-content').style.maxHeight = thatParent.querySelector('.collapsible-content').scrollHeight + 'px';
            } else {
                that.classList.remove('is-active');
                thatParent.querySelector('.collapsible-content').style.maxHeight = '';
            }
        }
    }
});

// Mobile Navigation
$(function () {
    var trigger = $('[data-trigger="mobile-navigation"], button[data-trigger="mobile-navigation"]'),
        close = $('[data-dismiss="mobile-navigation"], div[data-dismiss="mobile-navigation"]'),
        mobileMenu = $('.mobile-menu'),
        body = $('body');

    function slideOpen(e) {
        if (!mobileMenu.hasClass('mobile-navigation-active')) {
            body.addClass('mobile-navigation-is-active');
            mobileMenu.addClass('mobile-navigation-active');
        } else {
            body.removeClass('mobile-navigation-is-active');
            mobileMenu.removeClass('mobile-navigation-active');
        }
    }

    function slideClose(e) {
        body.removeClass('mobile-navigation-is-active');
        mobileMenu.removeClass('mobile-navigation-active');
    }

    trigger.on('click', slideOpen);
    close.on('click', slideClose);
});

// Hide/show navigation
$(function () {
    var social = $('.blog-article-social-list'),
        header = $('header'),
        w = $(window);

    var anchorPoint = $('.blog-article-content');

    var direction,
        threshold = 200,
        scrollAmount = 0;

    var topL = 0;

    var tween = TweenMax.to(social, 0.4, {
        translateY: '-100%',
        ease: Power4.easeInOut,
    }).reverse();

    $(window).on('resize', function() {
        if (w.width() < 767) {
            topL = social.parent().offset().top;
        }
    });

    if (w.width() < 767) {
        topL = social.parent().offset().top;
    }

    if (anchorPoint.length > 0) {
        function sticky() {
            if (w.width() < 767) {
                if (w.scrollTop() + header.innerHeight() >= topL) {
                    social.addClass('sticky');

                    if (w.scrollTop() >= (anchorPoint.innerHeight() + anchorPoint.offset().top) - header.innerHeight()) {
                        social.css({
                            position: 'absolute',
                            top: (anchorPoint.innerHeight() + anchorPoint.offset().top) - (header.innerHeight() + social.innerHeight()) + 'px'
                        });
                    } else {
                        social.css({
                            position: '',
                            top: '',
                        });
                    }
                } else {
                    social.removeClass('sticky');
                }
            } else {
                social.removeClass('sticky');
                social.css({
                    position: '',
                    top: '',
                });
            }

            requestAnimationFrame(sticky);
        }

        sticky();

        function hideShow() {

            if (w.width() < 767) {
                if (social.hasClass('sticky')) {
                    if (direction === 'up' && scrollAmount >= threshold && w.scrollTop() >= social.innerHeight()) {

                        scrollAmount = 0;

                        if (!tween.isActive()) {
                            tween.play();
                        }
                    } else if (direction === 'down') {

                        scrollAmount = 0;

                        if (!tween.isActive()) {
                            tween.reverse();
                        }

                    }
                } else {

                    if (!tween.isActive()) {
                        tween.reverse();
                    }

                }
            }

            requestAnimationFrame(hideShow);

        }

        hideShow();

        var lastScrollTop = 0;

        window.addEventListener("scroll", function () {

            if (w.width() < 767) {
                scrollAmount += 50;

                var st = window.pageYOffset || document.documentElement.scrollTop;

                if (st > lastScrollTop) {
                    direction = 'down';
                } else {
                    direction = 'up';
                }

                lastScrollTop = st <= 0 ? 0 : st;
            }

        }, false);
    }
});

// Custom Dropdown
$(function () {
    var dropdown = $('.custom-dropdown'),
        body = $('body'),
        trigger = $('a[data-trigger="custom-dropdown"]'),
        target;

    var blogNavDropdown = $('.blog-navbar .nav-dropdown').find(dropdown);
    var regularNavDropdown = $('.navbar .nav-dropdown').find(dropdown);

    var a, b;

    function showNavigation(e) {
        target = $(e.target).parent().find(dropdown);

        $(e.target).parent().siblings().find(dropdown).hide();
        $(e.target).parent().siblings().find(dropdown).removeClass('custom-dropdown-open');

        if ($(e.target).closest('nav').hasClass('blog-navbar')) {
            regularNavDropdown.hide();
            regularNavDropdown.removeClass('custom-dropdown-open');
        } else {
            blogNavDropdown.hide();
            blogNavDropdown.removeClass('custom-dropdown-open');
        }

        $(e.target).closest('.nav-dropdown').find(trigger).addClass('custom-dropdown-is-open');

        target.show();
        setTimeout(function () {
            target.addClass('custom-dropdown-open');
        }, 50);
    }

    function hideNavigation() {
        trigger.removeClass('custom-dropdown-is-open');

        b = setTimeout(function () {
            dropdown.removeClass('custom-dropdown-open');
            a = setTimeout(function () {
                dropdown.hide();
            }, 300);
        }, 150);
    }

    function initMenu() {
        if ($(window).width() < 768) {
            if (!body.hasClass('has-mobile-navigation')) {
                body.addClass('has-mobile-navigation');

                body.off('mouseover');

                body.on('click', function (e) {
                    clearTimeout(a);
                    clearTimeout(b);

                    if (trigger.is(e.target) || trigger.has(e.target).length > 0) {
                        target = $(e.target).parent().find(dropdown);

                        e.preventDefault();

                        $(e.target).parent().siblings().find(dropdown).hide();
                        $(e.target).parent().siblings().find(dropdown).removeClass('custom-dropdown-open');
                        $(e.target).closest('.nav-dropdown').find('.nav-link').removeClass('custom-dropdown-is-open');

                        if (!target.hasClass('custom-dropdown-open')) {
                            target.show();
                            target.addClass('custom-dropdown-open');
                        } else {
                            $(e.target).parent().find(dropdown).hide();
                            $(e.target).parent().find(dropdown).removeClass('custom-dropdown-open');
                            $(e.target).closest('.nav-dropdown').find(trigger).removeClass('custom-dropdown-is-open');
                        }
                    }
                });
            }
        } else {
            body.removeClass('has-mobile-navigation');

            body.off('click');

            body.on('click', function (e) {
                clearTimeout(a);
                clearTimeout(b);

                if (trigger.is(e.target) || trigger.has(e.target).length > 0) {
                    return true;
                }
            });

            body.on('mouseover', function (e) {
                clearTimeout(a);
                clearTimeout(b);

                if (trigger.is(e.target) || trigger.has(e.target).length > 0 || dropdown.is(e.target) || dropdown.has(e.target).length > 0) {
                    showNavigation(e);
                } else {
                    hideNavigation();
                }
            });
        }
    }

    $(window).on('resize', initMenu);
    initMenu();
});

// Load single div backgrounds
$(function () {
    var image = document.querySelectorAll('img[data-bg="true"], [data-bg="true"]');

    for (var i = 0; i < image.length; i++) {
        (function (n) {
            var img = new Image();

            img.onload = imageFound;
            img.onerror = imageNotFound;
            img.src = image[n].src;

            function imageFound() {
                image[n].parentNode.style.backgroundImage = 'url(' + img.src + ')';

                if ($(image[n]).parent().is('.bg')) {
                    $(image[n]).parent().css({
                        opacity: '1'
                    });
                }
            }

            function imageNotFound() {
                image[n].parentNode.style.backgroundColor = '#F8F9FD';
            }
        }(i));
    }
});

// Language selector redirect
$(function () {
    var langSelector = $('.language-selector select'),
        langOptionTarget;

    langSelector.on('change', function (e) {
        var that = $(e.target);

        langOptionTarget = $(that[0].options[that[0].selectedIndex]).data('href');

        if (that[0].options[that[0].selectedIndex].hasAttribute('data-href') && $(that[0].options[that[0].selectedIndex]).data('href').length > 0) {
            window.open(langOptionTarget, '_self');
        }
    });
});

// Custom dropdown
$(function () {
    let $trigger = $('div[data-toggle="select-box"]'),
        $option = $('.select-box-custom-option');

    function toggleSelect() {
        let $this = $(this);

        $('.select-box-custom').not($this.closest('.select-box-custom')).removeClass('active');

        if (!$this.closest('.select-box-custom').hasClass('active')) {
            $this.closest('.select-box-custom').addClass('active');
        } else {
            $this.closest('.select-box-custom').removeClass('active');
        }
    }

    function selectOption(e) {
        e.preventDefault();
        let $this = $(this);

        if ($this.closest('.select-box-custom').find('.select-box-custom-selected').length) {
            if ($this[0].hasAttribute('data-lang')) {
                $this.closest('.select-box-custom').find('.select-box-custom-selected').text($this.data('lang'));
            } else {
                $this.closest('.select-box-custom').find('.select-box-custom-selected').text($this.text());
            }
        }

        if ($this[0].hasAttribute('data-href')) {
            window.open($this.data('href'), '_self');
        }

        //Update <select> value
        $this.closest('.select-box-custom').next().val($this.closest('.select-box-custom').find('.select-box-custom-dropdown').find('li').eq($this.index()).text());

        //Remove "active' class from custom select
        $('.select-box-custom').removeClass('active');
    }

    $(document).on('mouseup', function (e) {
        let container = $('.select-box-custom');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('active');
        }
    });

    $(document).on('keydown', function (e) {
        let keyCode = e.keyCode || e.which;

        if (keyCode == 9) {
            if ($('.select-box-custom').hasClass('active')) {
                $('.select-box-custom').removeClass('active');
            }
        }
    });

    $(document).on('click', 'div[data-toggle="select-box"]', toggleSelect);
    $(document).on('click', '.select-box-custom-option', selectOption);
    $trigger.click(toggleSelect);
    $option.click(selectOption);
});

// Replace old select with custom dropdown
$(function () {
    let $field = $('select[class*="gfield_select"], select, .select');

    $field.each(function () {
        let $this = $(this);

        var placeholder = $this.data('placeholder') !== undefined ? $this.data('placeholder') : $this.find('option:first-child').text() || $this.parent().hasClass("language-selector") ? $this.find('option').data('lang') : $this.data('placeholder');

        let $template = $('<div class="select-box-custom">' +
            '    <div class="select-box-custom-selected" data-toggle="select-box">' + placeholder + '</div>' +
            '    <ul class="select-box-custom-dropdown">' +
            '    </ul>' +
            '</div>');

        $template.insertBefore($this);
        $this.find('option').each(function () {
            let $thisOption = '<li class="select-box-custom-option">' + $(this).text() + '</li>';

            $this.prev().find('.select-box-custom-dropdown').append($thisOption);

            if ($(this)[0].hasAttribute('data-href')) {
                $this.prev().find('.select-box-custom-dropdown').find('.select-box-custom-option').eq($(this).index()).attr('data-href', $(this).data('href'));
            }

            if ($(this)[0].hasAttribute('data-lang')) {
                $this.prev().find('.select-box-custom-dropdown').find('.select-box-custom-option').eq($(this).index()).attr('data-lang', $(this).data('lang'));
            }
        });
    });
});

// Mobile - toggle search
$(function () {
    var trigger = $('.mobile-blog-navbar-search');

    var opened = false;

    function toggleSearch() {
        var that = $(this);

        opened = !opened;

        if (opened) {
            $('.blog-navbar-search').css({
                display: 'block',
            });
            that.find('i').removeClass('fa-search').addClass('fa-times');
        } else {
            $('.blog-navbar-search').css({
                display: '',
            });
            that.find('i').addClass('fa-search').removeClass('fa-times');
        }

    }

    trigger.on('click', toggleSearch);
});

// Sticky blog hero content
$(function () {
    var heroContent = $('.blog-article-hero-content'),
        heroMedia = $('.blog-article-hero-media'),
        articleContent = $('.blog-article-content'),
        articleBack = $('.blog-article-back'),
        article = $('.blog-article'),
        w = $(window);

    var containerFluid = document.querySelector('.container-fluid'),
        containerFluidStyle = window.getComputedStyle(containerFluid);

    function stickyHero() {

        if ((w.scrollTop() + 90) >= article.offset().top && w.width() > 1023) {
            if ((w.scrollTop() + 90) < (articleContent.offset().top + articleContent.innerHeight()) - heroContent.innerHeight() + 10) {
                articleBack.css({
                    position: 'fixed',
                    top: 90 + 40 + 'px',
                    left: containerFluidStyle.getPropertyValue('padding-left'),
                });
            } else {
                articleBack.css({
                    position: 'absolute',
                    top: (articleContent.innerHeight() + heroMedia.innerHeight() - heroContent.innerHeight()) + 90 - 40 + 'px',
                    left: '',
                });
            }
        } else {
            articleBack.css({
                position: '',
                top: '',
                left: '',
            });
        }

        if ((((w.height() / 2) + w.scrollTop()) + 40) >= (heroMedia.offset().top + (heroMedia.innerHeight() / 2))) {
            if (w.width() > 1023) {
                heroContent.css({
                    position: 'fixed',
                    top: 'calc(50% - ' + ((heroContent.innerHeight() / 2)) + 'px + 45px)',
                    width: `calc(45% - 22px)`,
                });

                heroContent.next().css({
                    marginLeft: 'auto',
                });

                if ((heroContent.innerHeight() + heroContent.offset().top) - 90 >= articleContent.offset().top + articleContent.innerHeight()) {
                    heroContent.css({
                        position: 'absolute',
                        top: (articleContent.innerHeight() + articleContent.offset().top) - heroContent.innerHeight() - 90 + 'px',
                    });
                }
            } else {
                heroContent.css({
                    position: '',
                    top: '',
                    width: '',
                });

                heroContent.next().css({
                    marginLeft: '',
                });
            }
        } else {
            heroContent.css({
                position: '',
                top: '',
                width: '',
            });

            heroContent.next().css({
                marginLeft: '',
            });
        }

        requestAnimationFrame(stickyHero);

    }

    if (heroContent.length > 0) {
        stickyHero();
    }
});

// Reveal on scroll
$(function () {

    const options = {
        threshold: 0.4,
        rootMargin: '0px 0px -15px 0px',
    };

    function onEntry(entry) {

        entry.forEach((change, i) => {

            if (change.isIntersecting) {

                var action = new TimelineMax({})
                    .to(change.target, 1, {
                        opacity: 1,
                        translateY: 0,
                        ease: Power4.easeOut,
                        delay: i - i * 0.9,
                    }).call(function () {
                        observer.unobserve(change.target);

                        if (change.target.classList.contains('blog-post-card')) {
                            change.target.classList.add('hoverable');
                            change.target.style.transform = '';
                        }
                    });

            }
        });
    }

    // instantiate a new Intersection Observer
    let observer = new IntersectionObserver(onEntry, options);

    // list of cards
    let elements = document.querySelectorAll('.blog-post-card, .blog-post-card-featured');

    // loop through all elements
    // pass each element to observe method
    for (let elm of elements) {
        observer.observe(elm);
    }

});